module.exports = __webpack_public_path__ + "img/LV.52915f25.svg";